// src/components/eventos/EventoRevisao.js
import React from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton,
} from '@chakra-ui/react';

const formatarData = (s) => {
    if (!s) return 'Data não informada';
    try { const [a, m, d] = s.split('T')[0].split('-'); return `${d}/${m}/${a}`; } catch { return 'Data inválida'; }
};
const formatarDataCompleta = (s) => {
    if (!s) return 'Data não informada';
    try {
        const [a, m, d] = s.split('T')[0].split('-').map(Number);
        const meses = ['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
        const dias = ['domingo','segunda-feira','terça-feira','quarta-feira','quinta-feira','sexta-feira','sábado'];
        const dt = new Date(a, m - 1, d);
        return `${dias[dt.getDay()]}, ${d} de ${meses[m - 1]} de ${a}`;
    } catch { return formatarData(s); }
};
const formatarTempo = (min) => {
    const h = Math.floor(Math.abs(min) / 60), m = Math.abs(min) % 60;
    return h > 0 ? `${h}h ${m}min` : `${m}min`;
};

const SmCheck = () => (
    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
);
const PlayIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3" /></svg>
);

const EventoRevisao = ({ isOpen, onClose, evento, onIniciarEvento }) => {
    if (!evento) return null;

    const tarefas = evento.tarefas || [];
    const totalTarefas = tarefas.length;
    const tempoProgramadoTotal = tarefas.reduce((a, t) => a + (t.duracao || 0), 0);
    const primeiraHora = tarefas[0]?.horaInicio || '—';
    const ultimaHora = tarefas[tarefas.length - 1]?.horaFim || '—';

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
            <ModalOverlay bg="rgba(0,0,0,0.4)" backdropFilter="blur(8px)" />
            <ModalContent bg="#ffffff" border="1px solid #e2e8f0" borderRadius="20px" color="#1e293b" mx={4} fontFamily="'Inter', -apple-system, sans-serif" boxShadow="0 20px 60px rgba(0,0,0,0.15)">
                <ModalHeader pb={3} borderBottom="1px solid #e2e8f0">
                    <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: '100px', background: 'rgba(96,165,250,0.1)', border: '1px solid rgba(96,165,250,0.2)', color: '#2563eb', fontSize: '11px', fontWeight: 700, marginBottom: '8px' }}>
                        PROGRAMA DO EVENTO
                    </span>
                    <p style={{ margin: 0, fontSize: '22px', fontWeight: 800, color: '#0f172a', letterSpacing: '-0.02em' }}>{evento.titulo}</p>
                </ModalHeader>
                <ModalCloseButton color="#94a3b8" />

                <ModalBody py={6} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    {/* Info card */}
                    <div style={{ background: '#eff6ff', border: '1px solid #93c5fd', borderRadius: '14px', padding: '20px' }}>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
                            {[
                                { label: 'Data', value: formatarDataCompleta(evento.data), color: '#2563eb' },
                                { label: 'Horário', value: `${primeiraHora} às ${ultimaHora}`, color: '#2CCB90' },
                                { label: 'Duração', value: formatarTempo(tempoProgramadoTotal), color: '#7c3aed' },
                                { label: 'Tarefas', value: `${totalTarefas} programadas`, color: '#d97706' },
                                ...(evento.local ? [{ label: 'Local', value: evento.local, color: '#ef4444' }] : []),
                            ].map((item, i) => (
                                <div key={i}>
                                    <p style={{ margin: '0 0 3px', fontSize: '11px', fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em' }}>{item.label}</p>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: item.color || '#1e293b' }}>{item.value}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Descrição */}
                    {evento.descricao && (
                        <div style={{ padding: '14px 16px', background: '#f8fafc', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                            <p style={{ margin: '0 0 6px', fontSize: '11px', fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Descrição</p>
                            <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>{evento.descricao}</p>
                        </div>
                    )}

                    {/* Cronograma */}
                    <div>
                        <p style={{ margin: '0 0 14px', fontSize: '15px', fontWeight: 700, color: '#0f172a' }}>Cronograma ({totalTarefas} tarefas)</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {tarefas.map((tarefa, idx) => (
                                <div key={tarefa.id} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '16px', transition: 'border-color 0.2s' }}
                                    onMouseEnter={e => e.currentTarget.style.borderColor = 'rgba(139,92,246,0.3)'}
                                    onMouseLeave={e => e.currentTarget.style.borderColor = '#e2e8f0'}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', flexWrap: 'wrap', marginBottom: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <span style={{ padding: '3px 10px', borderRadius: '7px', background: 'rgba(139,92,246,0.1)', border: '1px solid rgba(139,92,246,0.2)', color: '#7c3aed', fontSize: '12px', fontWeight: 700 }}>#{idx + 1}</span>
                                            <span style={{ fontSize: '14px', fontWeight: 700, color: '#0f172a' }}>{tarefa.titulo}</span>
                                        </div>
                                        <span style={{ padding: '3px 10px', borderRadius: '7px', background: 'rgba(45,184,225,0.08)', border: '1px solid rgba(45,184,225,0.2)', color: '#2DB8E1', fontSize: '12px', fontWeight: 600 }}>
                                            ⏱ {tarefa.duracao} min
                                        </span>
                                    </div>

                                    <div style={{ padding: '8px 12px', background: '#eff6ff', borderLeft: '3px solid #93c5fd', borderRadius: '6px', marginBottom: '8px', fontSize: '13px', fontWeight: 600, color: '#2563eb' }}>
                                        ⏰ {tarefa.horaInicio} – {tarefa.horaFim}
                                    </div>

                                    {(tarefa.responsavel || tarefa.local) && (
                                        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '8px' }}>
                                            {tarefa.responsavel && <span style={{ fontSize: '12px', color: '#64748b' }}><strong style={{ color: '#1e293b' }}>Responsável:</strong> {tarefa.responsavel}</span>}
                                            {tarefa.local && <span style={{ fontSize: '12px', color: '#64748b' }}><strong style={{ color: '#1e293b' }}>Local:</strong> {tarefa.local}</span>}
                                        </div>
                                    )}

                                    {(tarefa.descricao_tipo === 'texto' || (!tarefa.descricao_tipo && tarefa.descricao)) && tarefa.descricao && (
                                        <div style={{ padding: '8px 10px', background: 'rgba(139,92,246,0.05)', borderLeft: '3px solid #a78bfa', borderRadius: '6px', marginTop: '8px' }}>
                                            <p style={{ margin: '0 0 4px', fontSize: '10px', fontWeight: 700, color: '#7c3aed', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Descrição</p>
                                            <p style={{ margin: 0, fontSize: '12px', color: '#64748b' }}>{tarefa.descricao}</p>
                                        </div>
                                    )}

                                    {tarefa.descricao_tipo === 'lista' && tarefa.descricao_items?.length > 0 && (
                                        <div style={{ padding: '8px 10px', background: 'rgba(44,203,144,0.05)', borderLeft: '3px solid #2CCB90', borderRadius: '6px', marginTop: '8px' }}>
                                            <p style={{ margin: '0 0 6px', fontSize: '10px', fontWeight: 700, color: '#2CCB90', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Itens da Tarefa</p>
                                            {tarefa.descricao_items.map((item, i) => (
                                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '6px', fontSize: '12px', color: '#64748b', padding: '2px 0' }}>
                                                    <span style={{ color: '#2CCB90', marginTop: '1px', flexShrink: 0 }}><SmCheck /></span>{item}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Resumo final */}
                    <div style={{ padding: '14px 16px', background: 'rgba(44,203,144,0.06)', border: '1px solid rgba(44,203,144,0.2)', borderRadius: '10px', fontSize: '13px', color: '#2CCB90', fontWeight: 600 }}>
                        ✓ Tudo pronto! O evento tem {totalTarefas} tarefa{totalTarefas !== 1 ? 's' : ''} programada{totalTarefas !== 1 ? 's' : ''} com duração total estimada de {formatarTempo(tempoProgramadoTotal)}.
                    </div>
                </ModalBody>

                <ModalFooter borderTop="1px solid #e2e8f0" gap={3}>
                    <button onClick={onClose} style={{ padding: '9px 20px', borderRadius: '10px', background: '#f8fafc', border: '1px solid #e2e8f0', color: '#64748b', fontSize: '13px', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
                        Fechar
                    </button>
                    {onIniciarEvento && (
                        <button onClick={() => { onIniciarEvento(evento); onClose(); }}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '7px', padding: '9px 20px', borderRadius: '10px', background: 'linear-gradient(135deg, #2CCB90, #22a876)', border: 'none', color: '#fff', fontSize: '13px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', boxShadow: '0 4px 16px rgba(44,203,144,0.25)' }}>
                            <PlayIcon /> Iniciar Evento
                        </button>
                    )}
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EventoRevisao;
